import { permissionManager } from "../PermissionManager/PermissionManager";
/**
    Edit text & image & shape
    Add text
    Add shape -> Line
    Add shape -> Square
    Add shape -> Circle
    Add shape -> Round Square
    Add images (From a file)
    Text font
    Text size
    Bold
    Italic
    Underline
    Font color
    // TODO:
    Flatten	Edit
    Add watermark
    Update watermark
    Remove all watermark
*/
export const FW_DOWNLOAD_FILE_BUTTON  = 'fw-download-file-button';

export const EDIT_TEXT_FONT           = 'font-family-dropdown';
export const EDIT_TEXT_SIZE           = 'font-size-dropdown';
export const EDIT_TO_ADD_TEXT         = 'fv--addon-add-text-button';
export const EDIT_TO_ALL_OBJECTS      = 'edit-all-objects';
export const EDIT_TO_ADD_SHAPE_LINE   = 'add-pathObject-line';
export const EDIT_TO_ADD_SHAPE_SQUARE = 'add-pathObject-square';
export const EDIT_TO_ADD_SHAPE_CIRCLE = 'add-pathObject-circle';
export const EDIT_TO_ADD_SHAPE_RECT   = 'add-pathObject-roundRect';
export const EDIT_TO_ADD_IMAGE        = 'image-tool';
export const EDIT_TO_BOLD_TEXT        = 'fv--addon-textobject-bold-style';
export const EDIT_TO_ITALIC_TEXT      = 'fv--addon-textobject-italic-style';
export const EDIT_TO_FONT_COLOR       = 'fv--addon-textobject-font-color';

// annot in edit

export const EDIT_WEB_LINKS_CREATE    = 'web-links-create';
export const EDIT_WEB_LINKS_REMOVE    = 'web-links-remove';
export const EDIT_LINK                = 'create-link';
export const EDIT_FILE_ATTACHMENT     = 'doc-attachment-button';
export const EDIT_IMAGE_ANNOTATION    = 'create-image';
export const EDIT_IMAGE_BOOKMARK      = 'create-bookmark';
export const EDIT_AUDIO_VIDEO         = 'multi-media-btn';
export const EDIT_APPEND_ALL_WEB_LINKS      = 'edit-append-all-web-links';
export const EDIT_VIEW_WEB_LINKS      = 'edit-view-web-links';

export const EDIT_ADD_ARTICLE      = 'article-button';

// touchup
export const EDIT_TEXT = 'edit-text';
export const EDIT_JOIN_SPLIT = 'join-split';
export const EDIT_JOIN_SPLIT_JOIN = 'join-split-join';
export const EDIT_JOIN_SPLIT_SPLIT = 'join-split-split';
export const EDIT_JOIN_SPLIT_LINK = 'join-split-link';
export const EDIT_JOIN_SPLIT_UNLINK = 'join-split-unlink';
export const EDIT_JOIN_SPLIT_SELECT_NONE = 'join-split-select-none';
export const EDIT_SEARCH_REPLACE = 'search-replace';

// premium features
export const EDIT_PREMIUM_BTNS = [
  EDIT_WEB_LINKS_CREATE,
  EDIT_WEB_LINKS_REMOVE,
  EDIT_APPEND_ALL_WEB_LINKS,
  EDIT_VIEW_WEB_LINKS,
  EDIT_LINK,
  EDIT_FILE_ATTACHMENT,
  EDIT_IMAGE_ANNOTATION,
  EDIT_AUDIO_VIDEO,
  EDIT_IMAGE_BOOKMARK,
  EDIT_TEXT_FONT,
  EDIT_TEXT_SIZE,
  EDIT_TO_ADD_TEXT,
  EDIT_TO_ALL_OBJECTS,
  EDIT_TO_ADD_SHAPE_LINE,
  EDIT_TO_ADD_SHAPE_SQUARE,
  EDIT_TO_ADD_SHAPE_CIRCLE,
  EDIT_TO_ADD_SHAPE_RECT,
  EDIT_TO_ADD_IMAGE,
  EDIT_TO_BOLD_TEXT,
  EDIT_TO_ITALIC_TEXT,
  EDIT_TO_FONT_COLOR,
  EDIT_TEXT,
  EDIT_JOIN_SPLIT,
  EDIT_JOIN_SPLIT_JOIN,
  EDIT_JOIN_SPLIT_SPLIT,
  EDIT_JOIN_SPLIT_LINK,
  EDIT_JOIN_SPLIT_UNLINK,
  EDIT_JOIN_SPLIT_SELECT_NONE,
  EDIT_SEARCH_REPLACE,
  EDIT_ADD_ARTICLE,
];
permissionManager.registerPremiumFeatures(EDIT_PREMIUM_BTNS);
permissionManager.registerCNJPPremiumFeatures([
  EDIT_TEXT,
  EDIT_JOIN_SPLIT,
  EDIT_ADD_ARTICLE,
  EDIT_WEB_LINKS_CREATE,
  EDIT_WEB_LINKS_REMOVE,
  EDIT_APPEND_ALL_WEB_LINKS,
  EDIT_VIEW_WEB_LINKS,
]);

export const EDIT_ALL_LIST = [
  EDIT_TEXT_FONT,
  EDIT_TEXT_SIZE,
  EDIT_WEB_LINKS_CREATE,
  EDIT_WEB_LINKS_REMOVE,
  EDIT_LINK,
  EDIT_FILE_ATTACHMENT,
  EDIT_IMAGE_ANNOTATION,
  EDIT_AUDIO_VIDEO,
  EDIT_IMAGE_BOOKMARK,
  EDIT_ADD_ARTICLE,

  EDIT_TO_ADD_TEXT,
  EDIT_TO_ALL_OBJECTS,
  EDIT_TO_ADD_SHAPE_LINE,
  EDIT_TO_ADD_SHAPE_SQUARE,
  EDIT_TO_ADD_SHAPE_CIRCLE,
  EDIT_TO_ADD_SHAPE_RECT,
  EDIT_TO_ADD_SHAPE_RECT,
  EDIT_TO_ADD_IMAGE,
  EDIT_TO_BOLD_TEXT,
  EDIT_TO_ITALIC_TEXT,
  EDIT_TO_FONT_COLOR,

  EDIT_TEXT,
  EDIT_JOIN_SPLIT,
  EDIT_JOIN_SPLIT_JOIN,
  EDIT_JOIN_SPLIT_SPLIT,
  EDIT_JOIN_SPLIT_LINK,
  EDIT_JOIN_SPLIT_UNLINK,
  EDIT_JOIN_SPLIT_SELECT_NONE,
  EDIT_SEARCH_REPLACE,
];


